import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AdminService } from '../../services/admin.service';
import { NgForm } from '@angular/forms';
import { Search } from '../../classes/search';
import { Title } from '@angular/platform-browser';
import { FileService } from '../../../onboarding/services/file.service';
import { saveAs as importedSaveAs } from "file-saver";
import { Router } from '@angular/router';

@Component({
  selector: 'app-review-page',
  templateUrl: './review-page.component.html',
  styleUrls: ['./review-page.component.scss']
})
export class ReviewPageComponent implements OnInit {

  constructor(
    private AdminService: AdminService,
    private titleService: Title,
    private FileService: FileService,
    private router: Router
  ) { }

  orgs: any;
  count: number;
  search: Search = <Search>{ status: null };
  currentPage: number;
  @ViewChild('archiveModal') public archiveModal: ModalDirective;
  @ViewChild('deleteModal') public deleteModal: ModalDirective;


  ngOnInit() {
    this.getCompanies();
    this.titleService.setTitle('Review Organizations');
  }

  getCompanies(page: number = 1) {
    this.AdminService.getCompanies(page, 10)
      .subscribe(orgs => {
        this.orgs = JSON.parse(orgs.organizations);
        this.count = JSON.parse(orgs.total_count);
        this.currentPage = 1;
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  searchOrgs(searchForm: NgForm) {
    this.AdminService.getCompanies(1, 10, this.search.term, this.search.status)
      .subscribe(orgs => {
        this.orgs = JSON.parse(orgs.organizations);
        this.count = JSON.parse(orgs.total_count);
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  archiveOrg(orgId: number) {
    this.AdminService.archiveOrg(orgId)
      .subscribe(orgs => {
        this.getCompanies();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  deleteOrg(orgId: number) {
    this.AdminService.deleteOrg(orgId)
      .subscribe(orgs => {
        this.getCompanies(this.currentPage);
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  pageChanged(event: any) {
    this.AdminService.getCompanies(event.page, 10)
      .subscribe(orgs => {
        this.orgs = JSON.parse(orgs.organizations);
        this.count = JSON.parse(orgs.total_count);
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  getCsv(orgId: number) {
    this.FileService.getCsv(orgId)
      .subscribe(blob => {
        importedSaveAs(new Blob([blob]), `${orgId}.zip`);
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/components/review-page/review-page.component.ts